// extracted by mini-css-extract-plugin
module.exports = {"button":"_7a3fb80146--button--V3g73","button--active":"_7a3fb80146--button--active--cziSj","label":"_7a3fb80146--label--w54KZ"};